import BigNumber from "bignumber.js";
export function serializeElrondTransaction({ amount, data, family, fees, gasLimit, mode, recipient, }) {
    return {
        family,
        amount: amount.toString(),
        recipient,
        mode,
        fees: fees ? fees.toString() : undefined,
        data,
        gasLimit,
    };
}
export function deserializeElrondTransaction({ amount, data, family, fees, gasLimit, mode, recipient, }) {
    return {
        family,
        mode,
        amount: new BigNumber(amount),
        recipient,
        fees: fees ? new BigNumber(fees) : undefined,
        data,
        gasLimit,
    };
}
//# sourceMappingURL=serializer.js.map